module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/secondary-tile-active.f9a9e4d5.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/secondary-tile-active.png
// module id = 2585
// module chunks = 11